import {
    FormControl,
    FormHelperText,
    MenuItem,
    Box,
    Checkbox,
    ListItemText,
    Typography,
    Menu,
} from "@mui/material"
import React from "react"
import {getOptions} from "../../misc/widget-functions"
import styled from "@emotion/styled"
import { ChevronDown } from "lucide-react"
import InfoIcon from "../../components/general/infoIcon"

export const multiDropdownWidgetPrototype = [
    {
        key: "infotext",
        type: "STRING",
        label: "infotext",
        size: 6,
    },
]

const DropdownBox = styled(Box)(({theme}) => theme.DROPDOWNBOX)

const MultiDropdownWidget = ({
                                 widget,
                                 value = [],
                                 selectOptions,
                                 onValueChange,
                                 triggerAction
                             }) => {
    const options = selectOptions ? selectOptions : getOptions(widget)
    const onMultiSelectChange = clickedValue => {
        const newValue = value.includes(clickedValue) ? value.filter(entry => entry !== clickedValue) : [...value, clickedValue]
        onValueChange(newValue)
    }

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const triggerOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const triggerCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <FormControl fullWidth>
            <Box display="flex" alignItems="center" gap={1} width="100%">
                <Box flexGrow={1}>
                    <DropdownBox onClick={triggerOpenMenu}>
                        <Typography>{widget.text}</Typography>
                        <ChevronDown/>
                    </DropdownBox>
                </Box>

                {widget.infotext && (
                    <Box display="flex" alignItems="center">
                        <InfoIcon
                            infoText={widget.infotext}
                            color={widget.color}
                        />
                    </Box>
                )}

            </Box>

            <Menu anchorEl={anchorEl} open={open} onClose={triggerCloseMenu}>
                {Array.isArray(options) &&
                    options.map(option => (
                        <MenuItem
                            key={option?.id}
                            value={option.value}
                            onClick={() => onMultiSelectChange(option.value)}
                            disabled={option?.disabled}
                        >
                            <Checkbox checked={value?.includes(option.value)} />
                            <ListItemText primary={option?.label} />
                        </MenuItem>
                    ))}
            </Menu>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

export default MultiDropdownWidget